angular.module('directives.dashboard').directive('wgtChart', function() {
    return {
        templateUrl: 'directives/dashboard/widgets/wgtChart/wgtChart.tpl.html',
        restrict: 'E',
        controller: wgtChartController
    };
});

// @ngInject
function wgtChartController($scope, $q, googleChartApiPromise, $element, $debounce, $rootScope, BusinessAreasApiService, $translate, DashboardApiService, $compile) {
    $scope.chart = {

        dataModel: {
            visual: {},
            metaData: {},
            data: {}
        },
        type: {},
        options: {}
    };
    $scope.activateChart = false;
    $scope.isLoaded = false;
    $scope.hasError = false;

    $scope.loadWidget = function () {
        var dataPromise = DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting);

        $q.all({
            data: dataPromise,
            api: googleChartApiPromise
        })
            .then(apiLoadSuccess);
    };
    $scope.loadWidget();
    BusinessAreasApiService.getBusinessAreas().then(function(data){
        $scope.businessAreas = data;
    });

    function apiLoadSuccess(response) {

        $rootScope.chartColorAssocArray = $rootScope.chartColorAssocArray || {};

        $scope.chart.type = 'BarChart';

        var _data = response.data.data;
        // Set chart options
        $scope.chart.options = {
            width: '100%',
            height: '100%',
            colors: [
                '#8dd3c7', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'
            ],
            animation: {
                duration: 1000,
                easing: 'out'
            },
            is3D: true,
            keepAspectRatio: 'false'
        };

        if (_data) {
            $scope.isLoaded = true;
        }

        var _array = [];

        var i;
        var data;
        var _seriesColor;
        var x;
        var __date;
        switch ($scope.item.name) {

            case 'sale-top-sold':
                for (i = 0; i < _data.length; i++) {
                    _array.push([_data[i].article.articleName, parseInt(_data[i].quantity)]);
                }
                data = new google.visualization.DataTable();
                data.addColumn('string', 'Name');
                data.addColumn('number', 'Quantity');
                data.addRows(_array);
                $scope.chart.dataModel.dataTable = data;
                $scope.chart.options.legend = {
                    position: 'none'
                };
                $scope.chart.type = 'BarChart';
                break;

            case 'sale-top-refund':
                for (i = 0; i < _data.length; i++) {
                    _array.push([_data[i].article.articleName, parseInt(_data[i].quantity)]);
                }
                data = new google.visualization.DataTable();
                data.addColumn('string', 'Name');
                data.addColumn('number', 'dashboard.quantity');
                data.addRows(_array);
                $scope.chart.options = {
                    colors: ['#e0440e', '#e6693e', '#ec8f6e', '#f3b49f', '#f6c7b6']
                };
                $scope.chart.options.legend = {
                    position: 'none'
                };
                $scope.chart.type = 'BarChart';
                $scope.chart.dataModel.dataTable = data;
                break;

            case 'sale-main-group':
                if($scope.selectedBusinessAreaId && $scope.selectedBusinessAreaId > 0 && $scope.businessAreas && $scope.businessAreas.length > 0){
                    $scope.selectedBusinessArea = $scope.businessAreas.filter(x => x.id === $scope.selectedBusinessAreaId)[0];
                }

                _seriesColor = [];

                for (i = 0; i < _data.length; i++) {
                    x = parseInt(_data[i].sum);
                    if (x > 0) {
                        _array.push([_data[i].mainGroupDescription, x]);
                        _seriesColor.push({color: getMySeriesColor(_data[i].mainGroupDescription)});
                    }
                }

                data = new google.visualization.DataTable();
                data.addColumn('string', 'Name');
                data.addColumn('number', 'Price');
                data.addRows(_array);
                $scope.chart.dataModel.dataTable = data;
                $scope.chart.type = 'PieChart';
                $scope.chart.options.title =  $scope.selectedBusinessArea && $scope.selectedBusinessArea.id > 0 ? $translate.instant("maingroup.businessarea") + ": " + $scope.selectedBusinessArea.code + " " + $scope.selectedBusinessArea.name : "";
                $scope.chart.options.slices = _seriesColor;
                $scope.chart.options.chartArea = {left:15,top:30};
                $scope.chart.options.width = 600;
                $scope.chart.options.height = 300;
                $scope.chart.options.fontSize = 11;
                $scope.chart.options.isStacked = true;
                break;

            case 'sale-stock-main-group':
                _seriesColor = [];
                for (i = 0; i < _data.length; i++) {
                    x = parseInt(_data[i].sum);
                    if (x > 0) {
                        _array.push([_data[i].mainGroupDescription, x]);
                        _seriesColor.push({color: getMySeriesColor(_data[i].mainGroupDescription)});
                    }
                }

                data = new google.visualization.DataTable();
                data.addColumn('string', 'Name');
                data.addColumn('number', 'Price');
                data.addRows(_array);
                $scope.chart.dataModel.dataTable = data;
                $scope.chart.type = 'PieChart';
                $scope.chart.options.slices = _seriesColor;
                break;

            case 'sale-30days':
                data = new google.visualization.DataTable();
                data.addColumn('date', 'Name');

                var j;

                //TODO: check this later when you have time
                for (j in $scope.currentUser.locations) {
                    data.addColumn('number', $scope.currentUser.locations[j].locationName);
                }

                for (i = 0; i < _data.length; i++) {

                    __date = new Date(_data[i].transactionDate.replace(new RegExp('-', 'g'), '/'));

                    var __marray = [];
                    __marray.push(__date);

                    for (j in $scope.currentUser.locations) {
                        x = 0;
                        try {
                            for (var t in _data[i].locationGroup) {
                                if (_data[i].locationGroup[t].location === $scope.currentUser.locations[j].locationName) {
                                    x = parseInt(_data[i].locationGroup[t].sum);
                                }
                            }
                        } catch (err) {
                        }

                        __marray.push({
                            v: x,
                            f: x + ' kr'
                        });
                    }

                    _array.push(__marray);
                }


                data.addRows(_array);
                $scope.chart.options = {
                    bar: {
                        groupWidth: '25%'
                    },
                    is3D: true
                };
                $scope.chart.dataModel.dataTable = data;
                $scope.chart.type = 'ColumnChart';
                $scope.chart.options.legend = {
                    position: 'right'
                };
                $scope.chart.options.isStacked = true;
                break;

            case 'sale-frequency':
                for (i = 0; i < _data.length; i++) {
                    x = parseInt(_data[i].quantity);
                    __date = new Date(_data[i].transactionDate.replace(new RegExp('-', 'g'), '/'));

                    _array.push([__date, null, 0, x]);
                }
                data = new google.visualization.DataTable();
                data.addColumn('date', 'Name');
                data.addColumn('number', 'Sum');
                data.addColumn('number', 'Sum1');
                data.addColumn('number', 'Sum2');
                data.addRows(_array);
                $scope.chart.options = {
                    highlightOnMouseOver: true,
                    maxDepth: 1,
                    maxPostDepth: 2,
                    minHighlightColor: '#8c6bb1',
                    midHighlightColor: '#9ebcda',
                    maxHighlightColor: '#edf8fb',
                    minColor: '#009688',
                    midColor: '#f7f7f7',
                    maxColor: '#ee8100',
                    headerHeight: 15,
                    showScale: true,
                    height: 500,
                    useWeightedAverageForAggregation: true
                };
                $scope.chart.dataModel.dataTable = data;
                $scope.chart.type = 'ColumnChart';
                break;
            case 'sale-top-sold-7days':
                for (i = 0; i < _data.length; i++) {
                    _array.push([_data[i].article.articleName, parseInt(_data[i].quantity)]);
                }
                data = new google.visualization.DataTable();
                data.addColumn('string', 'Name');
                data.addColumn('number', 'Quantity');
                data.addRows(_array);
                $scope.chart.dataModel.dataTable = data;
                $scope.chart.options.legend = {
                    position: 'none'
                };
                $scope.chart.type = 'BarChart';
                break;
        }

        function getBusinessAreas(){
            BusinessAreasApiService.getBusinessAreas().then(function (businessAreasResponse){
                return businessAreasResponse
            });
        }

        function getMySeriesColor(key) {
            if (null !== key || key !== undefined) {
                key = key.trim();
                var colors = ['#8dd3c7', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'];

                if ($rootScope.chartColorAssocArray[key] === undefined) {
                    $rootScope.chartColorAssocArray[key] = colors[Object.keys($rootScope.chartColorAssocArray).length];
                }

                return $rootScope.chartColorAssocArray[key];
            }
        }

        initChart();
        drawChart();

        function initChart() {
            $element.find('.chart-container').empty();

            $scope.chart.elId = 'chart-' + Math.floor((Math.random() * 6000) + 1);
            $element.find('.chart-container')
                .append($compile("<div google-chart class='google_chart chart' chart='chartObject' id='" + $scope.chart.elId + "'></div>")($scope));

        }

        function drawChart() {
            //check for data
            var chart = new google.visualization[$scope.chart.type](document.getElementById($scope.chart.elId));
            chart.draw($scope.chart.dataModel.dataTable, $scope.chart.options);
        }


        $scope.$on('gridster-resized', function (sizes, gridster) {
            $debounce(drawChart, 1);
        });

        $scope.$on('gridster-item-resized', function (item) {
            $debounce(drawChart, 1);
        });
    }

}
